import { useEffect } from "react";
import { useSelector } from "react-redux";

import formatUrl from "utils/FormatUrl";
import useTranslation from "next-translate/useTranslation";

export const buildUrl = (region, province, commune, lang = "fr") => {
  const url = `/prix-immobilier-maroc${
    region
      ? `/${region
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .trim()
          .replace(/ /g, "-")}`
      : ""
  }${
    province
      ? `/${province
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .trim()
          .replace(/ /g, "-")}`
      : ""
  }${
    commune
      ? `/${commune
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .trim()
          .replace(/ /g, "-")}`
      : ""
  }`;
  return formatUrl(url, lang);
};

export default function PrixImmoRouterUrlHelper() {
  let prices_redux = useSelector(
    (state: { carteprix: any }) => state.carteprix.prices
  );

  const region = prices_redux?.region;
  const province = prices_redux?.province;
  const commune = prices_redux?.commune;
  const { lang } = useTranslation("");
  useEffect(() => {
    if (region || province || commune) {
      const url = buildUrl(region, province, commune, lang);

      window.history.pushState({}, "", url);
      // if (process.env.NEXT_PUBLIC_DATADOG_ENABLED) {
    }
  }, [region, province, commune]);
  return <></>;
}
